import { useCallback } from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type EmailSMSLoginFormType } from './useAuthFormHelper';
import { useMobileNumberValidation } from './useMobileNumberValidation';

export const useMobileNumberFieldValidation = ({ setError }: UseFormReturn<EmailSMSLoginFormType>) => {
	const checkMobileNumberAvailability = useMobileNumberValidation();

	return useCallback(
		async (params: {
			countryCode: EmailSMSLoginFormType['country']['iso2'];
			mobileNumber: EmailSMSLoginFormType['id'];
		}) => {
			const { error, formattedValues } = await checkMobileNumberAvailability(params);

			if (error) {
				const { field, ...rest } = error;

				// TODO: OFT-1459 - We need to remove the below condition once we get rid of the old login flow.
				setError(field === 'mobileNumber' ? 'id' : field, rest);

				return;
			}

			return formattedValues;
		},
		[setError, checkMobileNumberAvailability]
	);
};
